import React from 'react';
import { Box, Button, Heading, Text, VStack } from '@chakra-ui/react';
import { ListPlus } from 'phosphor-react';

export interface EmptyStateAction {
  label: string;
  onClick: () => void;
}

export interface EmptyStateProps {
  title: string;
  description: string;
  action?: EmptyStateAction;
  testId?: string;
  variant?: 'card' | 'bare';
}

export function EmptyState({
  title,
  description,
  action,
  testId = 'empty-state',
  variant = 'card',
}: EmptyStateProps) {
  const framing =
    variant === 'card' ? { borderRadius: 'xl', boxShadow: 'card', background: 'surface.base' } : {};
  return (
    <VStack
      data-testid={testId}
      role="status"
      aria-label={`${title}. ${description}`}
      spacing="12px"
      px="24px"
      py="48px"
      textAlign="center"
      width="100%"
      {...framing}
    >
      <Box color="content.faint" aria-hidden="true">
        <ListPlus size={24} />
      </Box>
      <Heading as="h2" size="md" color="content.strong">
        {title}
      </Heading>
      <Text fontSize="13px" color="content.body" maxWidth="420px">
        {description}
      </Text>
      {action && (
        <Button variant="outline" size="sm" onClick={action.onClick} aria-label={action.label}>
          {action.label}
        </Button>
      )}
    </VStack>
  );
}
